import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const categories = [
  { id: 'all', label: 'All Tools', icon: '🌌' },
  { id: 'my-tools', label: 'My Custom Tools', icon: '🛠️' },
  { id: 'free', label: 'Free Tools', icon: '🆓' },
  { id: 'lifetime', label: 'Lifetime Deals', icon: '💎' },
  { id: 'productivity', label: 'Productivity', icon: '⚡' },
  { id: 'design', label: 'Design', icon: '🎨' },
  { id: 'marketing', label: 'Marketing', icon: '📈' },
  { id: 'development', label: 'Development', icon: '💻' }
];

const CategoryTabs = ({ currentCategory, onCategoryChange }) => {
  const location = useLocation();
  const isReviewsPage = location.pathname === '/reviews';
  const isToolsPage = location.pathname === '/tools';
  const isHomePage = location.pathname === '/';

  return (
    <motion.div 
      className="category-tabs"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* All Tools Tab - Navigation Link */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0, duration: 0.5 }}
        whileHover={{ 
          scale: 1.05,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.95 }}
      >
        <Link 
          to="/tools" 
          className={`tab ${isToolsPage ? 'active' : ''}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <span style={{ marginRight: '8px' }}>🌌</span>
          All Tools
        </Link>
      </motion.div>

      {/* Reviews Tab - Navigation Link */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
        whileHover={{ 
          scale: 1.05,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.95 }}
      >
        <Link 
          to="/reviews" 
          className={`tab ${isReviewsPage ? 'active' : ''}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <span style={{ marginRight: '8px' }}>📝</span>
          Reviews
        </Link>
      </motion.div>

      {/* Other Category Tabs - Filter Functionality (only show on homepage) */}
      {isHomePage && categories.slice(1).map((category, index) => (
        <motion.div
          key={category.id}
          className={`tab ${currentCategory === category.id ? 'active' : ''}`}
          onClick={() => onCategoryChange(category.id)}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: (index + 2) * 0.1, duration: 0.5 }}
          whileHover={{ 
            scale: 1.05,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.95 }}
        >
          <span style={{ marginRight: '8px' }}>{category.icon}</span>
          {category.label}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default CategoryTabs;